/**
 * Drop-in replacement for react-meta-tags that works with React 18.
 * Sets document title / meta tags via DOM APIs (no react-helmet SideEffect).
 */
var React = require("react");

function textOf(node) {
  if (node == null || typeof node === "boolean") return "";
  if (typeof node === "string" || typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(textOf).join("");
  if (React.isValidElement(node)) return textOf(node.props.children);
  return "";
}

function upsertMeta(attrs) {
  var selector = "";
  if (attrs.name) selector = 'meta[name="' + attrs.name + '"]';
  else if (attrs.property) selector = 'meta[property="' + attrs.property + '"]';
  else return;

  var el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    if (attrs.name) el.setAttribute("name", attrs.name);
    if (attrs.property) el.setAttribute("property", attrs.property);
    document.head.appendChild(el);
  }
  if (attrs.content != null) el.setAttribute("content", String(attrs.content));
}

function applyChildren(children) {
  React.Children.forEach(children, function (child) {
    if (!React.isValidElement(child)) return;
    var type = child.type;
    var props = child.props || {};

    if (type === "title") {
      document.title = textOf(props.children);
      return;
    }

    if (type === "meta") {
      upsertMeta(props);
    }
  });
}

function MetaTags(props) {
  React.useLayoutEffect(function () {
    applyChildren(props.children);
  }, [props.children]);

  return null;
}

module.exports = MetaTags;
module.exports.default = MetaTags;
module.exports.MetaTags = MetaTags;
